import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    agreeTerms: false
  });

  const [formStatus, setFormStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);

    try {
      // Submit to Supabase if you have it set up, or just show success
      console.log('Form submitted:', formData);
      
      setFormStatus('success');
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        agreeTerms: false
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus('error');
    } finally {
      setLoading(false);
    }
  };

  const openSocial = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="page-hero">
        <h1>Contact Us</h1>
        <p>Get in touch with our team</p>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            {/* Left Side - Contact Info */}
            <div className="contact-info">
              <h2>Reach Us</h2>
              
              {/* Address */}
              <div className="contact-card">
                <div className="contact-card-icon">📍</div>
                <div className="contact-card-content">
                  <h3>Address</h3>
                  <p>
                    Hampton Apartment, Flats F4,<br />
                    2 Mungo Park Close, Off Onitsha Crescent<br />
                    Asokoro, Abuja, FCT
                  </p>
                </div>
              </div>

              {/* Africa Secretariat */}
              <div className="contact-card">
                <div className="contact-card-icon">📞</div>
                <div className="contact-card-content">
                  <h3>Africa Secretariat</h3>
                  <p>
                    +234 703 294 1519<br />
                    +234 905 625 5065
                  </p>
                </div>
              </div>

              {/* American Secretariat */}
              <div className="contact-card">
                <div className="contact-card-icon">📞</div>
                <div className="contact-card-content">
                  <h3>American Secretariat</h3>
                  <p>+1-412-287-9069</p>
                </div>
              </div>

              {/* Email */}
              <div className="contact-card">
                <div className="contact-card-icon">✉️</div>
                <div className="contact-card-content">
                  <h3>Email</h3>
                  <p>info@abvig.com</p>
                </div>
              </div>

              {/* Website */}
              <div className="contact-card">
                <div className="contact-card-icon">🌐</div>
                <div className="contact-card-content">
                  <h3>Website</h3>
                  <p>www.abvig.com</p>
                </div>
              </div>

              {/* Social Links */}
              <div className="contact-social">
                <h3>Connect With Us</h3>
                <div className="social-links">
                  <button 
                    className="social-btn" 
                    aria-label="Facebook"
                    onClick={() => openSocial('https://facebook.com/abvig')}
                  >
                    📘
                  </button>
                  <button 
                    className="social-btn" 
                    aria-label="Twitter"
                    onClick={() => openSocial('https://twitter.com/abvig')}
                  >
                    🐦
                  </button>
                  <button 
                    className="social-btn" 
                    aria-label="LinkedIn"
                    onClick={() => openSocial('https://linkedin.com/company/abvig')}
                  >
                    🔗
                  </button>
                  <button 
                    className="social-btn" 
                    aria-label="Instagram"
                    onClick={() => openSocial('https://instagram.com/abvig')}
                  >
                    📸
                  </button>
                  <button 
                    className="social-btn" 
                    aria-label="YouTube"
                    onClick={() => openSocial('https://youtube.com/abvig')}
                  >
                    ▶️
                  </button>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className="contact-form-wrapper">
              <h2>Send a Message</h2>
              <p className="form-intro">
                Have a question, inquiry, or want to discuss a partnership? 
                Fill out the form below and our team will get back to you promptly.
              </p>

              {formStatus === 'success' && (
                <div className="form-success">
                  <h3>✓ Message Sent!</h3>
                  <p>Thank you for contacting us. Our team will get back to you within 24 hours.</p>
                </div>
              )}

              {formStatus === 'error' && (
                <div className="form-error">
                  <h3>⚠️ Submission Error</h3>
                  <p>There was a problem sending your message. Please try again or contact us directly.</p>
                </div>
              )}

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Full Name *</label>
                  <input 
                    type="text" 
                    name="fullName"
                    placeholder="Your full name" 
                    value={formData.fullName}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input 
                      type="email" 
                      name="email"
                      placeholder="your@email.com" 
                      value={formData.email}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input 
                      type="tel" 
                      name="phone"
                      placeholder="Your phone number" 
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Subject *</label>
                  <input 
                    type="text" 
                    name="subject"
                    placeholder="Message subject" 
                    value={formData.subject}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea 
                    name="message"
                    rows="5" 
                    placeholder="Your message..." 
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="form-group checkbox-single">
                  <label className="checkbox-label">
                    <input 
                      type="checkbox" 
                      name="agreeTerms"
                      checked={formData.agreeTerms}
                      onChange={handleChange}
                      required 
                    />
                    I agree to the terms and conditions
                  </label>
                </div>

                <button type="submit" className="btn-gold submit-btn" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;